/**
 * The Lucentra Systems lockup. The asset carries the red-and-chrome mark and dark lettering,
 * so on the dark theme it sits on a white plate (`--logo-plate`) rather than being recoloured
 * — the brand colours stay exactly as supplied in both themes.
 */
export function Brand({ large = false }: { large?: boolean }) {
  return (
    <span className="brand">
      <img
        className={large ? 'brand-logo brand-logo-lg' : 'brand-logo'}
        src="/brand/lucentra-systems.png"
        alt=""
        width={500}
        height={149}
      />
      <span className="visually-hidden">Lucentra Systems</span>
    </span>
  );
}
